
import React, { useEffect } from 'react';
import { useIsMobile } from '@/hooks/use-mobile';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import MobileHeader from '@/components/mobile/MobileHeader';
import MobileBottomNav from '@/components/mobile/MobileBottomNav';
import InternalAuthForm from '@/components/auth/InternalAuthForm';

const Login = () => {
  const isMobile = useIsMobile();
  
  // Scroll to top on page load
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  
  return (
    <div className="flex flex-col min-h-screen bg-black w-full">
      {!isMobile && <Header />}
      {isMobile && <MobileHeader />}
      
      <main className="flex-grow mt-24 flex items-center justify-center py-6 md:py-12 w-full px-4 md:px-6 pb-20 md:pb-6">
        <div className="w-full max-w-4xl mx-auto">
          <InternalAuthForm />
        </div>
      </main>
      
      {!isMobile && <Footer />}
      {isMobile && <MobileBottomNav />}
    </div>
  );
};

export default Login;
